import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_BASE } from "../constants/global";
import authContext from "../context/auth/authContext";
import { SwalBox } from "../entity/GlobalJS";

const SlideList = ({ course, handleCertified }) => {
    const cntxAuth = useContext(authContext);
    const { _slug } = useParams();
    const _token = localStorage.getItem('lmstoken');
    const [outer_slides, setOuterSlides] = useState('');
    const [sections, setSections] = useState('');
    const [active_lession, setActiveLession] = useState('');
    const [refresh, setRefresh] = useState(0);
    const [showFinish, setShowFinish] = useState(false);
    const [certified, setCertified] = useState(false);

    useEffect(() => {
        fetchMaterials();
        handleCertified(certified);
    }, [refresh, certified]);

    const fetchMaterials = async () => {
        const response = await fetch(`${API_BASE}get-learning-materials/${_slug}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Bearer " + _token
            },
        });

        const data = await response.json();
        if (data.status) {
            setOuterSlides(data.data.outer_slides);
            setSections(data.data.sections);
            setShowFinish(data.data.showFinish);
            setCertified(data.data.certified);
        } else {
            setOuterSlides('');
            setSections('');
        }
    }

    const updateProgress = async (e, id) => {
        var forData = new FormData();
        forData.append('course_id', course.id);
        forData.append('slide_id', id);

        const response = await fetch(`${API_BASE}update-progress/${e.target.checked}`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: forData
        });

        const data = await response.json();
        if (data.status) {
            if (data.data.completed) {
                cntxAuth.updateMessage({ message: data.message, type: 'success' });
                setRefresh(!refresh);
            } else {
                setRefresh(!refresh);
            }
        } else {
            cntxAuth.updateMessage({ message: data.message, type: 'danger' });
        }
    }

    const finishCourse = () => {
        SwalBox.fire({
            title: 'Are you sure?',
            text: `This will complete the course and you won't receive any future updates or attend future sessions.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                finishCourseProcess();
            }
        });
    }

    const finishCourseProcess = async () => {
        var forData = new FormData();
        forData.append('course_id', course.id);

        const response = await fetch(`${API_BASE}finish-course`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: forData
        });

        const data = await response.json();
        if (data.status) {
            if (data.data.completed) {
                cntxAuth.updateMessage({ message: data.message, type: 'success' });
                setRefresh(!refresh);
            } else {
                setRefresh(!refresh);
            }
        } else {
            cntxAuth.updateMessage({ message: data.message, type: 'danger' });
        }
    }

    return (
        <>
            {
                (course !== '' && typeof course !== 'undefined')
                &&
                <div className="accordion" id="accordionExample">
                    <div className="side_bar_count">
                        <ul>
                            {
                                outer_slides !== ''
                                &&
                                outer_slides.map((slide, indexx) =>
                                    <SlideBox key={indexx} index={indexx} slide={slide} updateProgress={updateProgress} showFinish={showFinish} certified={certified} />
                                )
                            }
                        </ul>
                    </div>

                    {
                        sections !== ''
                        &&
                        sections.map((section, index) => {
                            return (
                                (typeof section.slides !== 'undefined' && section.slides.length > 0)
                                &&
                                <div key={index} className="card">
                                    <div className="card-header" id={`heading${index}`}>
                                        <button className={`accordion-button ${index > 0 ? 'collapsed' : ''}`} type="button" data-toggle="collapse" data-target={`#collapseOne${index}`} aria-expanded={`${index > 0 ? false : true}`} aria-controls={`collapseOne${index}`}>
                                            Section {index + 1}: {section.title}<span>{section.completed}/{section.slide_count} | {section.duration}</span>
                                        </button>
                                    </div>
                                    <div id={`collapseOne${index}`} className={`collapse ${index > 0 ? '' : 'show'}`} aria-labelledby={`heading${index}`} data-parent="#accordionExample">
                                        <div className="card-body">
                                            <ul>
                                                {
                                                    section.slides.map((slide, indexx) =>
                                                        <SlideBox key={indexx} index={indexx} slide={slide} updateProgress={updateProgress} showFinish={showFinish} certified={certified} />
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        )
                    }
                    {
                        (showFinish && certified == false) ? <button onClick={() => { finishCourse() }} className="btn btn-circle btn-md submit-pink-btn back-button-course float-right pl-3 pr-3 pt-1 pb-1 mt-2 ek-lrs-course-completed" data-ek-lrs-title={course.title} data-ek-lrs-url={`/learn-course/`+course.slug}> Finish Course</button> : null
                    }
                </div>
            }
        </>
    );
}

export default SlideList;


const SlideBox = ({ index, slide, updateProgress, showFinish, certified }) => {
    const { _slug } = useParams();
    const { _slide } = useParams();
    const navigate = useNavigate();
    const [checked, setChecked] = useState(slide.completed);

    const loadSlide = (slide) => {
        if (_slide !== slide.toString()) {
            navigate(`/learn-course/${_slug}/${slide}`);
        }
    }

    return (
        <>
            <li className={_slide == slide.uid ? 'active ek-lrs-lesson-initialized' : 'ek-lrs-lesson-initialized'} data-ek-lrs-material-title={slide.title} data-ek-lrs-material-url={btoa(unescape(encodeURIComponent(slide.material.material)))} data-ek-lrs-material-duration={slide.duration} data-ek-lrs-material-type={slide.material.material_type} data-ek-lrs-material-parent="">
                <input type="checkbox" disabled={certified} checked={checked} onChange={(e) => { updateProgress(e, slide.id); setChecked(e.target.checked); }} className="ek-lrs-lesson-completed" data-ek-lrs-material-title={slide.title} data-ek-lrs-material-url={btoa(unescape(encodeURIComponent(slide.material.material)))} data-ek-lrs-material-duration={slide.duration} data-ek-lrs-material-type={slide.material.material_type} data-ek-lrs-material-parent=""/>
                <label onClick={(e) => { loadSlide(slide.uid); }}>
                    {index + 1}. {slide.title}
                    <span>
                        {
                            slide.material.material_type === 'Video'
                            &&
                            <i className="fas fa-play-circle"> </i>
                        }

                        {
                            slide.material.material_type !== 'Video'
                            &&
                            <i className="fas fa-file-alt"> </i>
                        }
                        &nbsp;
                        {slide.duration}
                    </span>
                </label>
            </li>
        </>
    );
}